import type * as React from 'react';

import { styled } from '@mui/material/styles';

const StyledAnchor = styled('a')({
    color: 'unset !important',
    cursor: 'pointer',
    display: 'contents',
    textDecoration: 'none !important',
});

export const UnstyledLink: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = (props) => {
    const { hidden, ...thisProps } = props;

    if (hidden) {
        return null;
    }

    return (
        <StyledAnchor {...thisProps}/>
    );
};